import script from "./LocationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationsTable.vue?vue&type=script&setup=true&lang=js"

import "./LocationsTable.vue?vue&type=style&index=0&id=77bd23cd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77bd23cd"]])

export default __exports__